<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div
        :class="field.hideFileNames ? 'hasNoCaption' : ' '"
        style="display: flex; align-items: center; flex-wrap: wrap"
      >
        <div class="custom-file gallery">
          <div>
            <span class="icon-add"></span>
            <span class="file-input-text">{{
              field.placeholder || $t("Select files")
            }}</span>
          </div>
          <input
            :id="field.attribute"
            ref="input"
            :class="errorClasses"
            :dusk="field.attribute"
            :multiple="field.multiple || false"
            :accept="field.mimeTypes"
            type="file"
            class="custom-file-input"
            @input="input($event)"
          />
        </div>
        <div v-if="hasAttached && field.multiple">
          <draggable
            v-model="sortables"
            :options="draggableOptions"
            class="field-attachments mt-4"
          >
            <div
              v-for="attachment in field.attached"
              :key="attachment.id"
              class="field-attachment field-attachment-draggable bg-light rounded p-2"
            >
              <attachment-preview
                :attachment="attachment"
                :options="previewOptions"
              />
              <button
                type="button"
                class="close remove-img"
                @click.prevent="remove(attachment)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </draggable>
        </div>
        <div v-if="hasAttached && !field.multiple">
          <div class="field-attachments mt-4">
            <div class="field-attachment bg-light rounded p-2">
              <attachment-preview
                :attachment="field.attached"
                :options="previewOptions"
              />
              <button
                type="button"
                class="close remove-img"
                @click.stop.prevent="clear()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import { FormAttachmentField } from "stylemix-base";

export default {
  name: "FormCustomAttachmentField",
  extends: FormAttachmentField,
};
</script>

<style lang="scss" scoped>
.field-attachments {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.field-attachment {
  position: relative;
  margin-right: 0;
  margin-bottom: 1rem;
}

.field-attachment-preview {
  font-size: 85%;
}

.field-attachment-draggable {
  cursor: move;
}
.remove-img {
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background-color: #ff6b6b !important;
  opacity: 1 !important;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  text-align: center;
  line-height: 1;
  position: absolute;
  font-size: 1rem;
  font-weight: normal;
  color: #fff;
}
.gallery {
  margin-right: 10px;
  width: 100px;
  height: 100px;
  margin-bottom: 0;
  background: #f8fcff;
  border: solid 1px #d3dee6;
  border-radius: 7px;
  text-align: center;
  cursor: pointer;
  position: relative;
  .custom-file-input {
    height: 100%;
    cursor: pointer;
  }
  .file-input-text {
    bottom: 5px;
    font-size: 14px;
    color: #9aa8b2;
    position: absolute;
    width: 100%;
    left: 2px;
  }
  .icon-add {
    display: inline-block;
    font-size: 26px;
    color: #cbd8e1;
    line-height: 80px;
    position: absolute;
    left: 50%;
    margin-left: -13px;
  }
}
</style>

<style lang="scss">
.hasNoCaption {
  .field-attachment-preview-image {
    a {
      display: none !important;
    }
    div {
      display: none;
    }
  }
}
.field-attachment-preview {
  img {
    border-radius: 10px;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
